const getBaseUrl = (baseUrl) => {
  if (baseUrl && typeof baseUrl === 'string' && baseUrl.trim() !== '') {
    return baseUrl.trim().replace(/\/+$/, '');
  }

  return '';
};

const isAbsoluteUrl = (url) => /^https?:\/\//i.test(url);

export const buildStreamUrl = (streamUrl, baseUrl = process.env.REACT_APP_API_URL) => {
  if (!streamUrl || typeof streamUrl !== 'string') {
    return null;
  }

  const trimmedStreamUrl = streamUrl.trim();
  const normalizedBaseUrl = getBaseUrl(baseUrl);

  if (trimmedStreamUrl === '') {
    return null;
  }

  if (isAbsoluteUrl(trimmedStreamUrl)) {
    if (!normalizedBaseUrl) {
      return trimmedStreamUrl;
    }

    try {
      const parsedStreamUrl = new URL(trimmedStreamUrl);
      const parsedBaseUrl = new URL(normalizedBaseUrl);

      if (parsedStreamUrl.host === parsedBaseUrl.host) {
        return `${parsedBaseUrl.origin}${parsedStreamUrl.pathname}${parsedStreamUrl.search}${parsedStreamUrl.hash}`;
      }
    } catch (error) {
      return trimmedStreamUrl;
    }

    return trimmedStreamUrl;
  }

  if (!normalizedBaseUrl) {
    return trimmedStreamUrl;
  }

  return `${normalizedBaseUrl}${trimmedStreamUrl.startsWith('/') ? trimmedStreamUrl : `/${trimmedStreamUrl}`}`;
};
